import React, { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import t from '~t';
import withEdit from '~co/user/withEdit';
import { avatarUpload } from '~data/actions/user';

import { Error } from '~co/overlay/dialog';
import { Label, buttonVariants, cn, Avatar, Icon } from '~ui';

function AccountProfileAvatar({ avatar, status }) {
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const onUpload = useCallback(
    (e) => {
      if (!e.target.files[0]) return;

      dispatch(
        avatarUpload(
          e.target.files[0],
          () => {},
          Error,
        ),
      );
    },
    [dispatch],
  );

  return (
    <>
      <Label>{t.s('avatar')}</Label>

      <div className='flex'>
        {avatar && (
          <Avatar
            className='mr-[var(--padding-small)]'
            //unlayered .icon rule beats layered utilities — size via inline style
            style={{ width: '64px', height: '64px' }}
            src={avatar}
          />
        )}

        <>
          <button
            type='button'
            className={cn(
              buttonVariants({ variant: 'outline' }),
              status == 'loading' && 'pointer-events-none opacity-50',
            )}
            disabled={status == 'loading'}
            onClick={() => inputRef.current?.click()}
          >
            <Icon name='upload' />
            {t.s('upload')}…
          </button>

          <input
            ref={inputRef}
            type='file'
            accept='image/*'
            capture='user'
            className='hidden'
            onChange={onUpload}
          />
        </>
      </div>
    </>
  );
}

export default withEdit(AccountProfileAvatar, ['avatar']);
